import { useSelector } from "react-redux";

/**
 * Returns the current state of the table (applied filters, sorted column, pagination details, etc.) that
 * is stored in the tablesReducer for the given table name
 *
 * @param  {string} tableName - The key in the tableReducer state that holds the table state data
 */
const useTableState = tableName => {
  return useSelector(state => state.tablesState[tableName]);
};

export default useTableState;
